import { AxiosError } from "axios"

class CommonHelper {
  public static getRandomPin(): string {
    const pin: number = Math.floor(1000 + Math.random() * 9000)
    return pin.toString()
  }

  public static voidFunction(): void {
    return
  }

  public static getErrorMessage(error: unknown, defaultMessage = "Oops!... Looks like an error occurred!"): string {
    if (error && typeof error === "object" && "response" in error) {
      const axiosError = error as AxiosError<{
        message?: string
        validation?: { body?: { message?: string } }
        error?: string
      }>
      return axiosError.response?.data?.validation?.body?.message ?? axiosError.response?.data?.message ?? axiosError.response?.data?.error ?? defaultMessage
    }
    return defaultMessage
  }

  public static getErrorResponse(error: unknown): { message?: string; validation?: { body?: { message?: string } } } | null {
    if (error && typeof error === "object" && "response" in error) {
      const axiosError = error as AxiosError<{
        message?: string
        validation?: { body?: { message?: string } }
      }>
      return axiosError.response?.data || null
    }
    return null
  }
}

export default CommonHelper
